export enum AuthErrorEnum {
  REFRESH_ACCESS_TOKEN_ERROR = "RefreshAccessTokenError",
  SSO_ERROR = "SsoError",
}
